import { SelectWithLabel } from '@adotel/components'
import { MenuItem } from '@material-ui/core'
import { FormikErrors, FormikTouched } from 'formik'

import GatewayPaymentTypeSelect from '../../components/GatewayPaymentTypeSelect'
import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Gateway } from '../../types/gateway'
import GatewayCredentialSwitch from './GatewayCredentialSwitch'
import GatewayFooter from './GatewayFooter'
import useStyles from './styles/GatewayCredential.styles'

interface GatewayCredentialProps {
  values: Gateway
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Gateway>
  touched: FormikTouched<Gateway>
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  isSubmitting: boolean
  loadingForSubmit: boolean
}

const GatewayCredential: React.FC<GatewayCredentialProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  loadingForSubmit
}) => {
  const classes = useStyles()
  return (
    <div>
      <SectionTitle title="Credential Mode" marginBottom />
      <div className={classes.inputsContainer}>
        <SelectWithLabel
          label={getTranslate('Credential')}
          name="credential.credentialMode"
          fullWidth
          value={values.credential.credentialMode}
          onChange={(event: { target: { value: any } }) =>
            setFieldValue('credential.credentialMode', event.target.value)
          }
          size="small"
          error={
            (touched.credential?.credentialMode &&
              !!errors.credential?.credentialMode) ||
            undefined
          }
          helpertext={
            touched.credential?.credentialMode
              ? getTranslate(errors.credential?.credentialMode || '')
              : undefined
          }>
          <MenuItem key="TerminalId" value="TerminalId">
            Terminal Id
          </MenuItem>
          <MenuItem key="ApiKey" value="ApiKey">
            Api Key
          </MenuItem>
          <MenuItem key="MerchantID" value="MerchantID">
            Merchant ID
          </MenuItem>
          <MenuItem key="UsernamePassword" value="UsernamePassword">
            {getTranslate('Username Password')}
          </MenuItem>
        </SelectWithLabel>
        <SelectWithLabel
          label={getTranslate('Gateway type')}
          name="credential.gatewaysType"
          fullWidth
          value={values.credential.gatewaysType}
          onChange={(event: { target: { value: any } }) =>
            setFieldValue('credential.gatewaysType', event.target.value)
          }
          size="small"
          error={
            (touched.credential?.gatewaysType &&
              !!errors.credential?.gatewaysType) ||
            undefined
          }
          helpertext={
            touched.credential?.gatewaysType
              ? getTranslate(errors.credential?.gatewaysType || '')
              : undefined
          }>
          <MenuItem key="CashInHotel" value="CashInHotel">
            {getTranslate('Cash In Hotel')}
          </MenuItem>
          <MenuItem key="Mellat" value="Mellat">
            {getTranslate('Mellat')}{' '}
          </MenuItem>
          <MenuItem key="Fanava" value="Fanava">
            {getTranslate('Fanava')}
          </MenuItem>
          <MenuItem key="Migmig" value="Migmig">
            {getTranslate('Migmig')}
          </MenuItem>
          <MenuItem key="MigmigAuthorized" value="MigmigAuthorized">
            {getTranslate('Migmig Authorized')}
          </MenuItem>
          <MenuItem key="Zarinpal" value="Zarinpal">
            {getTranslate('Zarinpal')}
          </MenuItem>
          <MenuItem key="Saman" value="Saman">
            {getTranslate('Saman')}
          </MenuItem>
          <MenuItem key="Top" value="Top">
            {getTranslate('Top')}
          </MenuItem>
          <MenuItem key="Tara" value="Tara">
            {getTranslate('Tara')}
          </MenuItem>
        </SelectWithLabel>
        <GatewayPaymentTypeSelect
          gatewaysType={values.credential.gatewaysType}
          value={values.basicDetails.paymentType}
          onChange={(paymentType) =>
            setFieldValue('basicDetails.paymentType', paymentType)
          }
          disabled={isSubmitting}
        />
      </div>
      <GatewayCredentialSwitch
        credentialMode={values.credential.credentialMode}
        values={values}
        setFieldValue={setFieldValue}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
        isSubmitting={isSubmitting}
      />
      <GatewayFooter loadingForSubmit={loadingForSubmit} />
    </div>
  )
}
export default GatewayCredential
